(function($) {
	$(() => {
		function scrollToTop() {
			$('html, body').animate({
				scrollTop: 0
			});
		}

		// Add Sumoselect for select fields
		$('.js-custom-select').SumoSelect({
			placeholder: 'Nincs megadva',
			forceCustomRendering: true,
			csvDispCount: 1,
			captionFormat: '{0} elem kiválasztva',
			captionFormatAllSelected: 'Összes kiválasztva',
			searchText: 'Keresés',
			locale: ['Rendben', 'Mégse', 'Összes kiválasztása']
		});

		$(document).on('click', '.previous-matches .match-box', function() {
			const $this = $(this);
			if (!$this.hasClass('active')) {
				$('.previous-matches .match-box.active').removeClass('active');
				$this.addClass('active');
			}
		});

		$(document).on('click', '.player-table tbody td:last-child', function() {
			const parentTr = $(this).parent();
			const prevImg = parentTr.parents('.player-table').eq(0).siblings('img').eq(0);
			if (!parentTr.hasClass('active')) {
				$('.player-table tbody tr.active').removeClass('active');
				parentTr.addClass('active');
				prevImg.addClass('hide');
				// TODO swap heatmap or passes image
				setTimeout(() => {
					prevImg.removeClass('hide');
				}, 300);
			}
		});

		$(document).on('click', '.ability-table tbody td:last-child', function() {
			const parentTr = $(this).parent();
			if (!parentTr.hasClass('active')) {
				$('.ability-table tbody tr.active').removeClass('active');
				parentTr.addClass('active');
				// TODO refresh data of ability-details
			}
		});

		objectFitImages();

		$('.tab-pane[id^="tabs-"]').matchHeight({
			byRow: false,
			property: 'height',
			remove: false
		});

		$(document).on('click', '.navigate-up', () => {
			scrollToTop();
		});

		$(document).on('click', '.navigate-back', () => {
			window.history.back();
		});
	});
})(jQuery);
